import { Serializable } from './deserialize.service';
import * as moment from 'moment';

export class UserSettings implements Serializable<UserSettings> {
    selectedCalendarView: string; //month, agendaWeek, agendaDay, listMonth
    calendarFrom: moment.Moment;

    deserialize(input) {
        // debugger;
        if (!input) {
            return this;
        }
        this.selectedCalendarView = input.selectedCalendarView;
        this.calendarFrom = input.calendarFrom;
        return this;
    }
}
